export const supplierIntegers = [];
export const supplierFloats = [];
export const supplierIsoStrings = [];
export const supplierWhiteList = ['id', 'name'];
export const supplierOptimisticList = [...supplierWhiteList, 'supplierCatalogs'];
